import  api from "./api"

export default class CreateService {
    static login(usn,psw){
        return api.post(`token`,{
            'username':usn,
            'password':psw
        }).catch(e=>{
            console.log(e);
        })
    }

    static downloadExcel(village_id){
        return api.get(`collect/ccro/download/excel?village_id=${village_id}`,{
            responseType: 'blob'
        }).catch(e=>{
            console.log(e);
        })
    }

    static downloadParcelExcel(village_id, stage){
        return api.get(`collect/ccro/download/excel/${stage}?village_id=${village_id}`,{
            responseType: 'blob'
        }).catch(e=>{
            console.log(e);
        })
    }

    static downloadSHP(data){
        return api.post(`collect/ccro/download/shp`,data).catch(e=>{
            console.log(e);
        })
    }


    static createDeedPlan(data) {
        return api.post(`spatial/create/deedplan`,data).catch(e=>{
            console.log(e);
        })
    }

    static uploadFile(url,data) {
        return api.post(url,data,{
            headers:{
                'Content-Type': 'multipart/form-data'
            }
        }).catch(e=>{ console.log(e);})
    }



    static createLayer(formData) {
        return api.post('collect/ccro/upload/shp',formData,{headers:{'Content-Type':'multipart/form-data'}}).catch(e=>{console.log(e);})
    }

    static createZIP(formData) {
        return api.post('collect/upload/mobile/data-backup',formData,{headers:{'Content-Type':'multipart/form-data'}}).catch(e=>{console.log(e);})
    }

    static createParty(formData) {
        return api.post('spatial/create/party',formData,{headers:{'Content-Type':'multipart/form-data'}}).catch(e=>{console.log(e);})
    }

    static createAllocation(data) {
        return api.post('spatial/allocate',data).catch(e=>{console.log(e);})
    }

    static createParcelRemark(data){
        console.log(data)
        return api.post(`collect/ccro/create/remark`,data).catch(e=>{console.log(e);})
    }

    static createSignatory(formData) {
        return api.post('projects/signatories/create',formData,{headers:{'Content-Type':'multipart/form-data'}}).catch(e=>{console.log(e);})
    }



    static updateDocumentCounter(data){
        return api.put('localities/update/document/counter',data).catch(e=>{console.log(e);})
    }

    static updateLocalitiesCode(data) {
        return api.put(`localities/update/locality/code`,data).catch(e=>{ console.log(e);})
    }

    static markPrinted(data){
        return api.put(`collect/ccro/change/stage`,data).catch(e=>{console.log(e);})
    }

    static askDownloadSHPStatus(task_id) {
        return api.get(`collect/ccro/download/shp?task_id=${task_id}`)
    }

    static questionnaireDownloadSHP(data){
        return api.post(`collect/questionnaires/download/shp`,data).catch(e=>{
            console.log(e);
        })
    }

    static askQuestionnaireDownloadSHPStatus(task_id) {
        return api.get(`collect/questionnaires/download/shp?task_id=${task_id}`)
    }

    static createFunder(data) {
        return api.post('setup/funders/create', data).catch(e => {
            console.log(e);
        });
    }
}
